import React, { useEffect, useMemo, useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import MainContent from "../../../layouts/maincontent/MainContent";
import emptyWallet from "../../../assets/img/empty-wallet2.png";
import { getWalletDetails } from "../../../adapters/apis/wallet/wallet";
import { get } from "../../../adapters/xhr/api";
import styles from "./UserTransactionAccount.module.css";

function UserTransactionAccount() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [walletData, setWalletData] = useState({
    balance: "0.00",
    walletTransaction: [],
  });

  useEffect(() => {
    checkVerfication();
  }, []);

  const checkVerfication = async () => {
    try {
      const response = await get("api/user/verifications", {}, true);
      const isFullyVerified =
         response?.data?.phone_verified;
      if (!isFullyVerified) {
        <Navigate to="/DisabledHome" replace />;
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    setIsLoading(true);
    setError("");

    getWalletDetails()
      .then((response) => {
        const wallet = response?.data?.data || {};
        setWalletData({
          balance: wallet?.balance || "0.00",
          walletTransaction: wallet?.walletTransaction || [],
        });
      })
      .catch(() => {
        setError("حدث خطأ أثناء تحميل بيانات المحفظة");
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const formattedBalance = useMemo(() => {
    const numericBalance = Number(walletData?.balance || 0);
    return Number.isNaN(numericBalance)
      ? walletData?.balance
      : numericBalance.toLocaleString("en-EG", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
  }, [walletData?.balance]);

  const formatDateTime = (dateValue) => {
    if (!dateValue) {
      return "-";
    }

    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) {
      return "-";
    }

    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    });
  };

  const getTransactionTypeClass = (type) => {
    return type === "إضافة" ? styles.typeAdd : styles.typeDeduct;
  };

  return (
    <MainContent>
      <section className={`${styles.sectionContent} section-content`}>
        <div className={`${styles.container} container`}>
          <div className={styles.headerRow}>
            <i
              className="fa-solid fa-arrow-right"
              aria-hidden="true"
              onClick={() => navigate("/user-settings")}
            ></i>
            <h4 className={`${styles.pageTitle} box-title mb-0`}>
              حساب تسويات المستخدم
            </h4>
          </div>

          <div className={styles.balanceCard}>
            <div className={styles.balanceInfo}>
              <h4 className={styles.balanceTitle}>رصيد التسويات</h4>
              <p className={styles.balanceValue}> {formattedBalance} جنيه</p>
            </div>
            <div className={styles.balanceIconWrap}>
              <img
                src={emptyWallet}
                alt="wallet"
                className={styles.walletIcon}
                width="120"
                height="120"
              />
            </div>
          </div>

          <h4 className={styles.tableTitle}>سجل المعاملات</h4>

          <div className={styles.tableWrapper}>
            <table className={styles.table}>
              <thead>
                <tr>
                  <th>نوع العملية</th>
                  <th>المبلغ</th>
                  <th>تاريخ و وقت العملية</th>
                  <th>رقم العملية</th>
                  <th> رقم الإقرار الذي تم عملية <br></br>من خلاله عملية الخصم/ الإستراداد</th>
                </tr>
              </thead>
              <tbody>
                {!isLoading && error && (
                  <tr>
                    <td colSpan="4" className={styles.errorCell}>
                      {error}
                    </td>
                  </tr>
                )}

                {!isLoading &&
                  !error &&
                  walletData.walletTransaction.length === 0 && (
                    <tr>
                      <td colSpan="4" className={styles.stateCell}>
                        لا توجد معاملات حتى الآن
                      </td>
                    </tr>
                  )}

                {!isLoading &&
                  !error &&
                  walletData.walletTransaction.length > 0 &&
                  walletData.walletTransaction.map((transaction) => (
                    <tr key={transaction.id}>
                      <td>
                        <span
                          className={`${styles.transactionType} ${getTransactionTypeClass(
                            transaction.transaction_type,
                          )}`}
                        >
                          {transaction.transaction_type}
                        </span>
                      </td>
                      <td>{Number(transaction.amount || 0).toFixed(2)} جنيه</td>
                      <td>{formatDateTime(transaction.created_at)}</td>
                      <td>{transaction.transaction_number || "-"}</td>
                      <td>{transaction.declaration_number || "-"}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>
    </MainContent>
  );
}

export default UserTransactionAccount;
